import { useEffect } from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import { CALLBACKS, triggerCallback } from "../../../utils/commonUtils";
import { getShopperCitFailureMessage } from "../../../utils/paymentOutcome";
import CheckoutComCardForm from "./CheckoutComCardForm";
import { useCheckout } from "../../../context/CheckoutContext";
import { useIframeResize } from "../../../hooks/useIframeResize";

const AltruonCheckoutComCardForm = ({
  formData,
  itemDetails,
  billingPlatformId,
  routingEntries,
  planId,
  platformItemDetails,
  checkoutPageConfDto,
  checkoutProcessDto,
  transparent,
  prefetchedGatewayConnection,
  tenantId,
  cardForm: CardForm = CheckoutComCardForm,
}) => {

  const queryParams = new URLSearchParams(window.location.search);
  const sessionId = queryParams.get("session_id");

  const { t } = useTranslation();
  const { triggerPaymentEvent } = useCheckout();

  useIframeResize({ enabled: true, padding: 40 });

  /**
   * Listen for "makePayment" from parent → trigger payment
   */
  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.type === "makePayment") {
        triggerPaymentEvent();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [triggerPaymentEvent]);

  /**
   * Handle card updates (only cardholderName)
   */
  const handleCardDataChange = (data) => {
    window.parent.postMessage(
      {
        type: "updateCardData",
        data: {
          cardholderName: data.cardholderName,
          saveCard: true,
        },
      },
      "*"
    );
  };

  const onParentCallback = (event) => {
    switch (event.type) {
      case "finalizeFormData":
        window.parent.postMessage(event, "*");
        break;

      case "actionRequired":
        triggerCallback(CALLBACKS.ACTION_REQUIRED, {
          actionType: "REDIRECT",
          redirectUrl: event.url,
          message: "Payment initiated, redirecting you to complete the process...",
        });
        break;

      case "success":
        triggerCallback(CALLBACKS.SUCCESS, {
          status: "success",
          transactionId: event.transactionId,
          message: "Payment successfully initiated.",
        });

        //Notify parent window that payment is successful
        window.parent.postMessage(
          {
            type: "paymentSuccess",
            data: { transactionId: event.transactionId },
          },
          "*"
        );
        break;

      default:
        triggerCallback(CALLBACKS.FAILURE, {
          status: "failed",
          message: getShopperCitFailureMessage(t),
        });
    }
  };

  return (
    <CardForm
      formData={formData}
      itemDetails={itemDetails}
      billingPlatformId={billingPlatformId}
      routingEntries={routingEntries}
      planId={planId}
      platformItemDetails={platformItemDetails}
      checkoutPageConfDto={checkoutPageConfDto}
      checkoutProcessDto={checkoutProcessDto}
      transparent={transparent}
      prefetchedGatewayConnection={prefetchedGatewayConnection}
      tenantId={tenantId}
      onCardDataChange={handleCardDataChange}
      onParentCallback={onParentCallback}
      sessionId={sessionId}
      isEmbeddedCheckout={true}
    />
  );
};

export default AltruonCheckoutComCardForm;
